// @flow
import type {Node} from 'react'
import React, {Component} from 'react'

import Value from 'components/proposals/Part/ui/Value'
import SummaryUI from 'components/proposals/Part/ui/Summary'
// eslint-disable-next-line import/named
import {Severity} from 'components/ui/Alert'
import SummarySections from 'components/proposals/Part/SummarySections'
import type {Change} from '../types'

type Props = {
  destroyPolicy: boolean,
  title: Value,
  body: Value,
  change: Change,
  domainDatabaseId: Value,
}

class Summary extends Component<Props> {
  get hasChanges(): boolean {
    return (
      this.props.title.isChanged
      || this.props.body.isChanged
      || this.props.domainDatabaseId.isChanged
    )
  }

  get alertMessage(): ?string {
    return this.props.destroyPolicy
      ? I18n.t('proposal.sentences.policy_will_be_removed')
      : null
  }

  get alertSeverity(): ?Severity {
    return this.props.destroyPolicy
      ? Severity.Warning
      : null
  }

  get lostChanges(): boolean {
    return this.hasChanges && this.props.destroyPolicy
  }

  render(): Node {
    return (
      <SummaryUI
        alertMessage={this.alertMessage}
        alertSeverity={this.alertSeverity}
        lostChanges={this.lostChanges}
      >
        <SummarySections change={this.props.change} />
      </SummaryUI>
    )
  }
}

export default Summary
